var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.color,"text-color":"white"}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-img',{attrs:{"src":_vm.wasteType.iconUrl}})],1),_vm._v(" "+_vm._s(_vm.wasteType.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }